import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import VueMatomo from 'vue-matomo';

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'

const app = createApp(App)

import { createVuetify } from 'vuetify'

import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/dist/vuetify.min.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
const vuetify = createVuetify({components,directives});

export default
    createVuetify({
      icons: {
            defaultSet: 'mdi',
            aliases,
            sets: {
              mdi,
            }
      },
  })

app.use(VueMatomo, {
  host: "https://mtb.bioinf.med.uni-goettingen.de/matomo",
  siteId: 10,
  router: router,
  enableLinkTracking: true,
  trackInitialView: true,
  debug: true,
});

app.use(router);
app.use(vuetify)
app.mount('#app');

window._paq.push(['trackPageView'])
